import { useEffect, useState } from "react";
import TICKERS from "../data/tickers.json";
import { API_BASE, authFetch } from "../auth";

// Bundled list: [{ s: symbol, n: name, l: 1 if public/logos/<s>.png exists }]
export const TICKER_LIST = TICKERS;
const BY_SYMBOL = new Map(TICKERS.map((t) => [t.s, t]));

export const lookupTicker = (symbol) => BY_SYMBOL.get(String(symbol || "").toUpperCase());

/* ── IBKR name fallback for symbols not in the bundled list ── */

const remoteNames = new Map(); // symbol -> name | null (null = IBKR doesn't know it)
const queued = new Set();
const listeners = new Set();
let timer = null;

function flush() {
  timer = null;
  const symbols = [...queued];
  queued.clear();
  if (!symbols.length) return;
  authFetch(`${API_BASE}/ticker-info/?symbols=${encodeURIComponent(symbols.join(","))}`)
    .then((res) => (res.ok ? res.json() : {}))
    .catch(() => ({}))
    .then((data) => {
      // Only cache definitive answers; a failed request (TWS down) is retried on next mount.
      symbols.forEach((s) => {
        if (s in data) remoteNames.set(s, data[s]);
      });
      listeners.forEach((fn) => fn());
    });
}

function requestName(symbol) {
  if (remoteNames.has(symbol) || queued.has(symbol)) return;
  queued.add(symbol);
  if (!timer) timer = setTimeout(flush, 300);
}

export function useTickerName(symbol) {
  const sym = String(symbol || "").toUpperCase();
  const local = BY_SYMBOL.get(sym);
  const [, bump] = useState(0);

  useEffect(() => {
    if (!sym || local) return undefined;
    const fn = () => bump((n) => n + 1);
    listeners.add(fn);
    // Wait until the symbol stops changing so half-typed tokens aren't looked up.
    const t = setTimeout(() => requestName(sym), 800);
    return () => {
      clearTimeout(t);
      listeners.delete(fn);
    };
  }, [sym, local]);

  return local ? local.n : remoteNames.get(sym) || "";
}
